import { Ring } from 'ldrs/react'
import 'ldrs/react/Ring.css'

const Spinner = ({
    size = "40",
    stroke = "5",
    bgOpacity = "0",
    speed = "2",
    color = "#007EFC"
}) => {
    return <Ring
        size={size}
        stroke={stroke}
        bgOpacity={bgOpacity}
        speed={speed}
        color={color}
    />
}

export default Spinner